module.exports = __webpack_public_path__ + "805d9746b578469ef2bd8519a183cb9d.png";